import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
export var Scene = /*#__PURE__*/function () {
  function Scene() {
    _classCallCheck(this, Scene);
    this.objects = [];
  }
  _createClass(Scene, [{
    key: "add",
    value: function add(obj) {
      this.objects.push(obj);
    }
  }, {
    key: "remove",
    value: function remove(id) {
      this.objects = this.objects.filter(function (obj) {
        return obj.id !== id;
      });
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.objects.find(function (obj) {
        return obj.id === id;
      });
    }
  }, {
    key: "forEach",
    value: function forEach(handler) {
      this.objects.forEach(function (obj, index) {
        try {
          handler(obj, index);
        } catch (err) {
          if (err instanceof Error) {
            console.error("render error: ".concat(err.message));
          }
        }
      });
    }
  }, {
    key: "clean",
    value: function clean() {
      this.objects = [];
    }
  }]);
  return Scene;
}();
export var CacheGroup = /*#__PURE__*/function (_Scene) {
  _inherits(CacheGroup, _Scene);
  var _super = _createSuper(CacheGroup);
  function CacheGroup(id) {
    var _this;
    _classCallCheck(this, CacheGroup);
    _this = _super.call(this);
    _this.needRedraw = true;
    _this.cacheCanvas = document.createElement('canvas');
    _this.setSize = function (width, height) {
      _this.cacheCanvas.width = width;
      _this.cacheCanvas.height = height;
    };
    _this.getCacheCanvas = function () {
      return _this.cacheCanvas;
    };
    _this.renderCache = function (renderer) {
      var ctx = _this.cacheCanvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, _this.cacheCanvas.width, _this.cacheCanvas.height);
        renderer(ctx);
      }
    };
    _this.id = id;
    return _this;
  }
  return _createClass(CacheGroup);
}(Scene);